import { PromotionBanner } from "@clipboard-health/ui-components";
import { WORKPLACE_REFERRALS_WITH_ACCOUNTS_PATH } from "@src/appV2/Accounts/WorkplaceReferrals";
import {
  WorkplaceReferralAction,
  WorkplaceReferralComponent,
} from "@src/appV2/Accounts/WorkplaceReferrals/types";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { useHistory } from "react-router-dom";

export function WorkplaceReferralsBanner() {
  const history = useHistory();

  const title = "Get paid for referring workplaces!";

  const handleClick = () => {
    logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
      action: WorkplaceReferralAction.BANNER_CLICKED,
      component: WorkplaceReferralComponent.WORKPLACE_REFERRAL_BANNER,
    });

    history.push(`${WORKPLACE_REFERRALS_WITH_ACCOUNTS_PATH}?source=workplaceReferralBanner`);
  };

  return (
    <PromotionBanner
      title={title}
      subtitle="Earn up to $1,000 for every workplace you refer to Clipboard, once their first shift is verified"
      icon="dollar-with-circle"
      backgroundColor={(theme) => theme.palette.common.white}
      borderColor={(theme) => theme.palette.onboarding!.inProgress.gradient}
      borderVariant="gradient"
      onClick={handleClick}
    />
  );
}
